import React from 'react';
import { Card, Typography } from 'antd';
import './CardVariant1.scss';

const { Title, Text } = Typography;

interface CardVariant1Props {
  day?: number;
}

const CardVariant1: React.FC<CardVariant1Props> = ({ day = 15 }) => (
  <Card className="card-variant1" bordered={false}>
    <div className="header">
      <Text className="serie-label">GÜNLÜK SERİ</Text>
      <Text className="hint">Uygulamayı <br/>Her Gün <br/>Ziyaret Et</Text>
    </div>
    <Title level={1} className="day-number">{day}.GÜN</Title>
  </Card>
);

export default CardVariant1;
